<template>
  <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-ndescuentover">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"><b>Detalles del Descuento</b></h5>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12 mb-0 pb-0" v-if="descuento.monto">
              <p class="mb-0"><b>Programa:</b> {{ datas.programa }}</p>
              <p class="mb-0 mt-0"><b>Concepto:</b> {{ descuento.concepto_pago.nombre }}</p>
              <p class="mb-0">
                <b>Monto de descuento:</b> <span class="blue--text">{{ descuento.monto }} Bs.</span>
              </p>
              <p class="mb-1"><b>Prorrateo:</b> {{ descuento.prorrateadoActivo ? 'SI' : 'NO' }}</p>
              <p class="mb-6"><b>Estado:</b> {{ descuento.estado }}</p>
              <p class="mb-1"><b>Descripcion:</b> {{ descuento.descripcion }}</p>
              <p class="mb-1"><b>Solicitado:</b> {{ parsefecha(descuento.fecha_registro) }}</p>
              <p class="mb-1"><b>Respondido:</b> {{ parsefecha2(descuento.fecha_respuesta_solicitud) }}</p>
              <p class="mb-1"><b>Motivo:</b> {{ descuento.motivo.descripcion }}</p>
              <p class="mb-6">
                <b>Estudiante:</b> {{ datas.nombres }} {{ datas.primer_apellido }} {{ datas.segundo_apellido }}
              </p>
              <p class="mb-1"><b>Solicitante:</b> {{ parseuser(descuento.user_solicitante) }}</p>
              <p class="mb-1"><b>Responsable:</b> {{ parseuser(descuento.user_responsable) }}</p>
            </div>
          </div>

          <p class="text-center text-danger">
            <b>{{ msg }}</b>
          </p>
          <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
          </div>

          <div class="text-right mt-1">
            <button type="button" class="btn btn-danger white--text" data-dismiss="modal">Cerrar detalle</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        area: { nombre: null },
        descuento: {},
        loading: false,
        msg: '',
        estado: '',
        respuesta: '',
        proceder_text: '',

        datas: { nombres: '' },
      };
    },
    watch: {},
    components: {},
    methods: {
      setdescuento(desc) {
        window.console.log(desc);
        if (!desc.concepto_pago) desc.concepto_pago = { nombre: '-' };
        this.descuento = desc;
        this.msg = '';
        this.estado = '';
        this.respuesta = '';
        this.proceder_text = '';
        this.loading = false;
        this.datas = { nombres: '' };
        this.getinscripcion(desc);
      },
      parsefecha(f) {
        if (!f) return '-';
        let fs = f.split(' ');
        let fs1 = fs[0].split('-');
        let fs2 = fs[1].split(':');
        return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
      },
      parsefecha2(f) {
        if (!f) return '-';
        let fs = f.split(' ');
        let fs1 = fs[0].split('-');
        return `${fs1[2]}/${fs1[1]}/${fs1[0]}`;
      },
      parseuser(u) {
        if (!u) return '-';
        if (!u.segundo_apellido) u.segundo_apellido = '';
        return `${u.nombres} ${u.primer_apellido} ${u.segundo_apellido}`;
      },
      getinscripcion(desc) {
        const vue = this;
        vue.datas.nombres = desc.estudiante.nombres;
        vue.datas.primer_apellido = desc.estudiante.primer_apellido;
        vue.datas.segundo_apellido = desc.estudiante.segundo_apellido;
        vue.datas.numero_documento = desc.estudiante.numero_documento;

        vue.datas.programa = desc.programa.nombre;

        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/${desc.id}`;
        xaxios.get(url).then(({ data }) => {
          window.console.log('DATA DESC::', data);
        });
      },
    },
    mounted() {
      var vue = this;
      window.$('#modal-ndescuentover').on('hide', function() {
        vue.area.nombre = null;
        vue.estado = true;
      });
    },
  };
</script>
